/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Page_StaffAttendanceListItemResponse_ } from '../models/Page_StaffAttendanceListItemResponse_';
import type { StaffAttendanceDetailResponse } from '../models/StaffAttendanceDetailResponse';
import type { StaffAttendanceScanRequest } from '../models/StaffAttendanceScanRequest';
import type { StaffAttendanceScanResponse } from '../models/StaffAttendanceScanResponse';
import type { StaffAttendanceSummaryResponse } from '../models/StaffAttendanceSummaryResponse';
import type { StaffAttendanceTrendResponse } from '../models/StaffAttendanceTrendResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StaffAttendanceRestControllerService {
  /**
   * getStaffAttendanceList
   * @returns Page_StaffAttendanceListItemResponse_ OK
   * @throws ApiError
   */
  public static getStaffAttendanceListUsingGet({
    date,
    limit,
    offset,
    search,
    status,
  }: {
    /**
     * date
     */
    date: string;
    limit?: number;
    offset?: number;
    /**
     * search
     */
    search?: string;
    /**
     * status
     */
    status?: string;
  }): CancelablePromise<Page_StaffAttendanceListItemResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/staff-attendance/list',
      query: {
        date: date,
        limit: limit,
        offset: offset,
        search: search,
        status: status,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * processScan
   * @returns StaffAttendanceScanResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static processScanUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: StaffAttendanceScanRequest;
  }): CancelablePromise<StaffAttendanceScanResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/staff-attendance/scan',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getStaffAttendanceDetails
   * @returns StaffAttendanceDetailResponse OK
   * @throws ApiError
   */
  public static getStaffAttendanceDetailsUsingGet({
    date,
    staffId,
  }: {
    /**
     * date
     */
    date: string;
    /**
     * staffId
     */
    staffId: string;
  }): CancelablePromise<StaffAttendanceDetailResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/staff-attendance/staff/{staffId}/details',
      path: {
        staffId: staffId,
      },
      query: {
        date: date,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getSummary
   * @returns StaffAttendanceSummaryResponse OK
   * @throws ApiError
   */
  public static getSummaryUsingGet({
    date,
  }: {
    /**
     * date
     */
    date: string;
  }): CancelablePromise<StaffAttendanceSummaryResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/staff-attendance/summary',
      query: {
        date: date,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getSummaryForRange
   * @returns StaffAttendanceSummaryResponse OK
   * @throws ApiError
   */
  public static getSummaryForRangeUsingGet({
    endDate,
    startDate,
  }: {
    /**
     * end-date
     */
    endDate: string;
    /**
     * start-date
     */
    startDate: string;
  }): CancelablePromise<StaffAttendanceSummaryResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/staff-attendance/summary/range',
      query: {
        'end-date': endDate,
        'start-date': startDate,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getCheckInTrend
   * @returns StaffAttendanceTrendResponse OK
   * @throws ApiError
   */
  public static getCheckInTrendUsingGet({
    endDate,
    startDate,
  }: {
    /**
     * end-date
     */
    endDate: string;
    /**
     * start-date
     */
    startDate: string;
  }): CancelablePromise<StaffAttendanceTrendResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/staff-attendance/trends/check-in',
      query: {
        'end-date': endDate,
        'start-date': startDate,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getCheckOutTrend
   * @returns StaffAttendanceTrendResponse OK
   * @throws ApiError
   */
  public static getCheckOutTrendUsingGet({
    endDate,
    startDate,
  }: {
    /**
     * end-date
     */
    endDate: string;
    /**
     * start-date
     */
    startDate: string;
  }): CancelablePromise<StaffAttendanceTrendResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/staff-attendance/trends/check-out',
      query: {
        'end-date': endDate,
        'start-date': startDate,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
